import { Box, styled } from '@mui/material';
import { ReactElement } from 'react';

const StyledBullet = styled(Box)(({ theme }) => ({
    color: '#d8d8d8',
    paddingInline: theme.spacing(1.25),
})) as typeof Box;

export const Bullet = (): ReactElement => <StyledBullet component="span">{'\u2022'}</StyledBullet>;
